import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[infiniteAutoScroll]',
})
export class InfiniteAutoScrollDirective implements OnInit, OnDestroy {
  @Input() scrollDelay = 50;
  @Input() stopAutoScroll = false;
  @Input() pauseDuration = 5000;

  private scrollInterval: number | null = null;
  private isHovered = false;
  private lastScrollTime = 0;
  private isPaused = false;

  constructor(private el: ElementRef) {}

  public ngOnInit(): void {
    this.startAutoScroll();
  }

  public ngOnDestroy(): void {
    if (this.scrollInterval) {
      cancelAnimationFrame(this.scrollInterval);
    }
  }

  private startAutoScroll(): void {
    const element = this.el.nativeElement;

    const scroll = (timestamp: number) => {
      if (!this.stopAutoScroll && !this.isHovered && !this.isPaused) {
        if (
          timestamp - this.lastScrollTime >= this.scrollDelay &&
          element.firstChild.scrollHeight >= element.firstChild.clientHeight * 1.02
        ) {
          element.firstChild.scrollTop += 1;

          if (element.firstChild.scrollTop >= element.firstChild.scrollHeight - element.firstChild.clientHeight) {
            this.pauseScrolling(() => {
              element.firstChild.scrollTop = 0;
            });
          } else if (element.firstChild.scrollTop <= 1) {
            this.pauseScrolling();
          }

          this.lastScrollTime = timestamp;
        }
      }

      this.scrollInterval = requestAnimationFrame(scroll);
    };

    this.scrollInterval = requestAnimationFrame(scroll);
  }

  private pauseScrolling(callback?: () => void): void {
    this.isPaused = true;

    setTimeout(() => {
      this.isPaused = false;

      if (callback) callback();
    }, this.pauseDuration);
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    if (!this.isPaused) {
      this.isHovered = true;
    }
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    if (!this.isPaused) {
      this.isHovered = false;
    }
  }
}
